import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNotify = () => {
    const el = document.getElementById('notify-form');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#0A0A0A]/95 backdrop-blur-sm border-b border-[#C9A84C]/10' : 'bg-transparent'
      }`}
    >
      <div className="px-6 md:px-12 h-16 flex items-center justify-between">
        <span
          className="font-mono text-[10px] md:text-xs tracking-[0.2em] text-[#F5F0E8]/60 lowercase select-none"
          style={{ fontFamily: "'JetBrains Mono', monospace" }}
        >
          timelessmemorieselasticeffects.com
        </span>

        <button
          onClick={handleNotify}
          className="hidden md:inline-flex items-center gap-2 px-5 py-2 rounded-full border border-[#F5F0E8]/30 text-[#F5F0E8]/70 text-xs tracking-widest uppercase font-light hover:border-[#C9A84C]/60 hover:text-[#C9A84C] transition-all duration-300 cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Notify Me
        </button>

        <button
          className="md:hidden text-[#F5F0E8]/60 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-[#0A0A0A]/98 border-t border-[#C9A84C]/10 px-6 py-6">
          <button
            onClick={() => { handleNotify(); setMenuOpen(false); }}
            className="w-full text-center py-3 rounded-full border border-[#F5F0E8]/30 text-[#F5F0E8]/70 text-xs tracking-widest uppercase cursor-pointer whitespace-nowrap"
          >
            Notify Me
          </button>
        </div>
      )}
    </nav>
  );
}
